import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { http, trackEvent } from "@/lib/api";
import { Card, PageTitle, btnPrimary } from "@/components/portal/ui";
import Deliverable from "@/components/portal/Deliverable";
import { ReviewCallCard } from "@/components/portal/ReviewCallCard";

export default function ReportView() {
  const nav = useNavigate();
  const [report, setReport] = useState(undefined);
  useEffect(() => { http.get("/portal/report?product=diagnostic").then((r) => { setReport(r.data); if (r.data) trackEvent("clarity_report_viewed", {}, { once: true }); }).catch(() => setReport(null)); }, []);

  if (report === undefined) return <div className="text-[#6B665E]">Loading…</div>;

  return (
    <div>
      <PageTitle eyebrow="Your $99 Diagnostic" title="Infant Sleep Clarity Report"
        sub="A professional interpretation of what appears to be happening, and where to focus first." />
      {!report ? (
        <Card className="p-8 text-center">
          <p className="font-display text-2xl text-[#1A1918]">Your report isn't ready yet</p>
          <p className="text-[#6B665E] mt-2 text-sm">Once your intake is reviewed, your Clarity Report appears here. If you haven't started your intake, do that first.</p>
          <button onClick={() => nav("/portal/diagnostic")} className={`${btnPrimary} mt-6`}>Go to Diagnostic intake</button>
        </Card>
      ) : (
        <>
          <Deliverable report={report} product="diagnostic" />
          <ReviewCallCard product="diagnostic"
            link="https://calendly.com/thenurturedparentcollective/my-clarity-report-review-with-andrea-hurley"
            label="Schedule Your Included 30-Minute Clarity Review"
            body="Your Clarity purchase includes one optional 30-minute video call with Andrea Hurley to review your Clarity Report and answer your questions. It's a one-time review — not ongoing coaching."
            eventName="clarity_review_call_click" testid="clarity-review-call" />
          <Card className="p-6 mt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
            <div>
              <p className="font-display text-xl text-[#1A1918]">Ready for the exact plan to follow?</p>
              <p className="text-[#6B665E] text-sm mt-1">A Personalized Blueprint turns these priorities into a step-by-step strategy.</p>
            </div>
            <button onClick={() => nav("/personalized-infant-sleep-blueprint")} className={btnPrimary}>Explore the Blueprint — $279</button>
          </Card>
        </>
      )}
    </div>
  );
}
